<template>
    <div class="page-container">

        <div class="page-header" :class="{ 'active' : showPageHeader }">

            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>

        </div>

        <router-link class="page-back-link" tag="div" :class="{ 'tiny' : showPageHeader }" to="/"
                     v-if="$route.path === '/booking/workplace'">
            <img src="/images/card/page-back-btn-icon.svg">
        </router-link>

        <transition name="modal">
            <div class="custom-modal show-custom-modal" @click="closeCustomModal()" v-if="modalVisible">
                <div class="custom-modal-window" @click.stop>

                    <div class="btn-close" @click="closeCustomModal()"></div>

                    <div class="custom-modal-body">
                        <masseur key="11" :clinic_description="modal_clinic_description" :clinic_image="modal_clinic_image"
                                 :clinic_name_person="modal_clinic_name_person"></masseur>
                    </div>

                </div>
            </div>
        </transition>

        <div class="page-body">

            <div class="container-fluid">
                <h1 class="mb-6">{{ pageTitle }}</h1>

                <div class="placeholder-glow w-100" :class="{ 'd-none' : fetcher.initialized }">

                    <span class="placeholder bg-info col-24 mb-4 rounded-2" style="height: 127px;"></span>
                    <span class="placeholder bg-info col-24 mb-4 rounded-2" style="height: 127px;"></span>
                    <span class="placeholder bg-info col-24 mb-4 rounded-2" style="height: 127px;"></span>

                </div>

                <div v-if="fetcher.initialized">

                    <div class="list mb-12">

                        <div class="list-item" v-if="workplaces.length === 0">
                            <h3>Din arbetsplats erbjuder inte massage för tillfället.</h3>
                        </div>

                        <div class="list-item" :key="'w'+workplace.id" v-for="workplace in workplaces" v-if="workplace.booking_is_active">
                            <h3>{{ workplace.title }}</h3>
                            <p class="mb-2" v-if="workplace.booking_description">{{ workplace.booking_description }}</p>
                            <a :href="workplace.booking_url"
                               target="_blank" class="btn btn-primary btn-sm w-auto" v-if="subscription_status.status === 'active' || subscription_status.status === 'ending'">Boka här</a>

                            <div @click="openCustomModal(workplace)" v-if="workplace.clinic_name_person">
                                <hr>
                                <div class="d-flex align-items-center" v-if="workplace.clinic_image">
                                    <div class="list-icon masseur">
                                        <div class="ratio ratio-1x1">
                                            <div>
                                                <img :src="'/storage/workplace-clinic-images/'+workplace.clinic_image"
                                                     class="w-100"
                                                     style="border-radius: 50%;">
                                            </div>
                                        </div>
                                    </div>
                                    <p style="width:calc(100% - 60px);">{{ workplace.clinic_name_person }} <img
                                        src="/images/card/list-headline-arrow-dark.svg" class="headline-arrow"></p>
                                </div>
                                <div class="d-flex align-items-center" v-else>
                                    <p class="w-100">{{ workplace.clinic_name_person }} <img
                                        src="/images/card/list-headline-arrow-dark.svg" class="headline-arrow"></p>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import scrollMixin from '../../../shared/mixins/scrollMixin'

import masseur from './masseur.vue'
import fetcher from '../../../shared/mixins/fetcher'

export default {

    mixins: [
        scrollMixin,
        fetcher
    ],

    components: {
        masseur
    },

    data () {
        return {
            pageTitle: 'Boka tid för massage på din arbetsplats',
            showPageHeader: false,
            loadingList: false,
            modalVisible: false,

            modal_clinic_name_person: '',
            modal_clinic_image: '',
            modal_clinic_description: '',

            workplaces: [],
            fetcher: {
                autoFill: [
                    'workplaces'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/workplaces'
        }
    },

    methods: {

        openCustomModal (workplace) {
            this.modal_clinic_name_person = workplace.clinic_name_person
            this.modal_clinic_image = workplace.clinic_image
            this.modal_clinic_description = workplace.clinic_description

            this.modalVisible = true

            jQuery('html').addClass('modal-open')
        },

        closeCustomModal () {
            this.modalVisible = false
            jQuery('html').removeClass('modal-open')
        }
    }
}
</script>
<style type="text/css">
/* --- Transition modal --- */
.modal-enter-active .custom-modal-window, .modal-leave-active .custom-modal-window {
    transform:translate(0, 0);
    transition: all 400ms ease-out;
}

.modal-enter .custom-modal-window, .modal-leave-to .custom-modal-window {
    transform:translate(0, 100%);
}
</style>
